class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '86d5f828';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1200.0.5';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Wed, 30 Sep 2026 14:16:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-09-30 10:16:28 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-09-30 10:16:28 Boston - 86d5f828 - 1200.0.5';
export default BuildTags;
